export function prettifyObjectKey(input: string): string {
  return input
    .replace(/([A-Z])/g, ' $1') // Add space before capital letters
    .trim() // Remove leading space if any
    .toLowerCase() // Convert the entire string to lowercase
    .replace(/^./, (char) => char.toUpperCase()); // Capitalize the first letter
}

export function formatDate(input: string | number | Date, format: 'shortDate' | 'dateTime') {
  const date = new Date(input);

  let formatOptions: Intl.DateTimeFormatOptions;
  switch (format) {
    case 'shortDate':
      formatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      };
      break;
    default:
      formatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      };
  }

  const formatter = new Intl.DateTimeFormat('se', formatOptions);
  return formatter.format(date);
}

export function formatDaysAgo(input: string | number | Date) {
  const givenDate = new Date(input);
  if (isNaN(givenDate.getTime())) {
    return `---`;
  }

  const now = new Date();
  const timeDiff = now.getTime() - givenDate.getTime();
  const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  if (daysDiff === 0) return `Created today.`;
  if (daysDiff === 1) return `Created yesterday`;
  return `Created ${daysDiff} days ago.`;
}
